export const UNIT_OF_MEASUREMENT = {
    BASE_PATH: '/unit/unit-of-measurement/',
    GET_ALL: '/unit-measurement',
    CREATE: '/unit-measurement/create',
    UPDATE: '/unit-measurement/update/',
    DELETE: '/unit-measurement/delete/',
    ADD_NEW_TITLE: 'Add New Unit of Measurement',
};
